/**
 * @engine/vfx - Node Index
 *
 * Exports all VFX node definitions and registers them.
 */

import { createBootstrap } from '@engine/graph';
import { vfxNodeRegistry } from '../VFXNodeRegistry';
import { SPAWN_NODES } from './spawn';
import { INIT_NODES } from './initialize';
import { UPDATE_NODES } from './update';
import { OUTPUT_NODES } from './output';
import { OPERATOR_NODES } from './operators';
import { EVENT_NODES } from './events';
import { VARIABLE_NODES } from './variables';
import { ALL_ATTRIBUTE_NODES } from './attributeModifiers';

// Re-export all node arrays
export { SPAWN_NODES } from './spawn';
export { INIT_NODES } from './initialize';
export { UPDATE_NODES } from './update';
export { OUTPUT_NODES } from './output';
export { OPERATOR_NODES } from './operators';
export { EVENT_NODES } from './events';
export { VARIABLE_NODES } from './variables';
export { ALL_ATTRIBUTE_NODES, SIMPLE_MODIFIER_NODES, ATTRIBUTE_MODIFIER_NODES } from './attributeModifiers';

/**
 * All VFX nodes combined.
 */
export const ALL_VFX_NODES = [
  ...SPAWN_NODES,
  ...INIT_NODES,
  ...UPDATE_NODES,
  ...OUTPUT_NODES,
  ...OPERATOR_NODES,
  ...EVENT_NODES,
  ...VARIABLE_NODES,
  ...ALL_ATTRIBUTE_NODES,
] as const;

/**
 * Register all built-in VFX nodes. Idempotent — safe to call multiple times
 * (guarded by the shared {@link createBootstrap} helper from `@engine/graph`).
 */
export const registerBuiltinVFXNodes = createBootstrap(() => {
  vfxNodeRegistry.registerAll(ALL_VFX_NODES);
});
